<template>
  <div class="border-b px-1 py-3 flex items-center flex-wrap">
    <div
      v-for="(attachment, index) in attachments"
      :key="attachment.idCustomerMessageAttachment"
      class="max-w-xs mb-1 mr-1"
    >
      <UploadAttachmentPreview
        v-if="attachment.isTypeUpload"
        :attachment="attachment"
        @remove="handleRemoveAttachment(index)"
      />

      <ReservationAttachmentPreview
        v-if="attachment.isTypeReservation"
        :attachment="attachment"
        @remove="handleRemoveAttachment(index)"
      />

      <OrderAttachmentPreview
        v-if="attachment.isTypeOrder"
        :attachment="attachment"
        @remove="handleRemoveAttachment(index)"
      />

      <CustomerFormAttachmentPreview
        v-if="attachment.isTypeCustomerForm"
        :attachment="attachment"
        @remove="handleRemoveAttachment(index)"
      />

      <GiftCardAttachmentPreview
        v-if="attachment.isTypeGiftCard"
        :attachment="attachment"
        @remove="handleRemoveAttachment(index)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ReservationAttachmentPreview from '../types/reservation/Preview.vue'
import UploadAttachmentPreview from '../types/upload/Preview.vue'
import OrderAttachmentPreview from '../types/order/Preview.vue'
import CustomerFormAttachmentPreview from '../types/customerForm/Preview.vue'
import GiftCardAttachmentPreview from '../types/giftCard/Preview.vue'

interface Props {
  attachments: any[]
}

const props = defineProps<Props>()

const handleRemoveAttachment = (index: number) => {
  props.attachments.splice(index, 1)
}
</script>
